import React from 'react';
import './footer.scss';
import logo from '../../assets/navbar/logoremala.png';
import awardsIntegrasi from '../../assets/iso/Integrasi.png';
import awards9001 from '../../assets/iso/ISO-9001.png';
import awards14001 from '../../assets/iso/ISO-14001.png';
import awards27001 from '../../assets/iso/ISO-27001.png';
import awards37001 from '../../assets/iso/ISO-37001.png';
import awards45001 from '../../assets/iso/ISO-45001.png';
import awards20000 from '../../assets/iso/ISO-20000.jpeg';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Link, useNavigate } from 'react-router-dom';

const FooterId = () => {
  const navigate = useNavigate();

  const handleToIntegrasi = () => {
    navigate(`/corporate-governance/quality-management/7/ims-00241`);
  };

  const handleTo9001 = () => {
    navigate(`/corporate-governance/quality-management/4/iso-9001`);
  };

  const handleTo37001 = () => {
    navigate(`/corporate-governance/quality-management/5/iso-37001`);
  };

  const handleTo27001 = () => {
    navigate(`/corporate-governance/quality-management/2/iso-27001`);
  };

  const handleTo45001 = () => {
    navigate(`/corporate-governance/quality-management/3/iso-45001`);
  };

  const handleTo14001 = () => {
    navigate(`/corporate-governance/quality-management/1/iso-14001`);
  };

  const handleTo20000 = () => {
    navigate(`/corporate-governance/quality-management/6/iso-20000-1`);
  };

  return (
    <>
      <div className="mainFooter stickyFooter">
        <div className="footerTop">
          <div className="footerLeft">
            <div className="firstLeft">
              <img src={logo} alt="Remala" className="logoFooter" />
              <div className="awardsImage">
                <img src={awardsIntegrasi} alt="ISO Integrasi" className="awards" onClick={handleToIntegrasi} />
                <img src={awards9001} alt="ISO 9001" className="awards" onClick={handleTo9001} />
                <img src={awards37001} alt="ISO 37001" className="awards" onClick={handleTo37001} />
              </div>
              <div className="awardsImage">
                <img src={awards27001} alt="ISO 27001" className="awards" onClick={handleTo27001} />
                <img src={awards45001} alt="ISO 45001" className="awards" onClick={handleTo45001} />
                <img src={awards14001} alt="ISO 14001" className="awards" onClick={handleTo14001} />
              </div>
              <img src={awards20000} alt="ISO 20000" className="logoAcs" onClick={handleTo20000} />
            </div>
            <div className="twoLeft">
              <h6>
                <strong>PT. Remala Abadi Tbk</strong>
              </h6>
              <p>Graha Mustika Ratu</p>
              <p>
                Jl. Gatot Subroto No 74-75, RT 02/ RW 01. <br />
                Menteng Dalam, Kec. Tebet, Kota Jakarta Selatan, <br />
                Daerah Khusus Ibukota Jakarta 12870
              </p>
              <br />
              <p>Telepon : (021) 83708889</p>
              <p>Email : corporatesecretary@remala.id</p>
              {/* <p>
                <h5>Visit Our Office :</h5>
              </p>
              <p>Monday – Saturday</p>
              <p>09 AM – 05 PM</p> */}
            </div>
          </div>
          <span className="borderLine"></span>
          <div className="footerMidle">
            <div className="pengumuman">
              <h6>Pengumuman</h6>
              <Link to="/investor-relation/activity/issuer-announcement">Pengumuman RUPS</Link>
              <Link to="/investor-relation/memo-information/memo-announcement">Pengumuman Paparan Publik</Link>
              <Link to="/investor-relation/activity/issuer-announcement">RUPS</Link>
            </div>
            <div className="laporan">
              <h6>Laporan</h6>
              <Link to="/investor-relation/report/financial-statements">Laporan Keuangan</Link>
              <Link to="#">Laporan Berkelanjutan</Link>
              <Link to="/investor-relation/report/annual-report">Laporan Tahunan</Link>
            </div>
            <div className="tautan">
              <h6>Tautan Penting</h6>
              <Link to="/aboutus/profile">Tentang Kami</Link>
              <Link to="/investor-relation/stock-information/stock-volume">Hubungan Investor</Link>
              <Link to="/corporate-governance/quality-management">Manajemen</Link>
            </div>
          </div>

          <div className="footerRight">
            <div className="rightTop">
              <h3>IKUTI KAMI</h3>
            </div>
            <div className="rightBottom">
              <a href="#" rel="noopener noreferrer">
                <InstagramIcon className="icon" />
              </a>
              <a href="#" rel="noopener noreferrer">
                <FacebookOutlinedIcon className="icon" />
              </a>
              <a href="#" rel="noopener noreferrer">
                <YouTubeIcon className="icon" />
              </a>
              <a href="#" rel="noopener noreferrer">
                <LinkedInIcon className="icon" />
              </a>
            </div>
          </div>
        </div>
        <hr />
        <div className="footerBottom">
          <p>Copyright &copy; Remala Group {new Date().getFullYear()} All Right Reserved</p>
        </div>
      </div>
    </>
  );
};

export default FooterId;
